import React from 'react';
import {Drawer, DrawerProps} from '@mantine/core';

export const EtroDrawerRoot: React.FC<Omit<DrawerProps, 'title'>> = props => {
  return <Drawer.Root {...props} />;
};
